import {Model} from "@vuex-orm/core";

export default class ProposalProductDetailDossierTraveller extends Model {

    static entity = 'proposalProductDetailDossierTraveller';

    static primaryKey = ['proposal_product_detail_id', 'dossier_traveller_id'];

    static fields () {
        return {
            proposal_product_detail_id: this.number(null),
            dossier_traveller_id: this.number(null),
        }
    }
}
